import React, { useRef, useCallback, forwardRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import TestimonyImage1 from "../../assets/Braiders/WebsiteBraids4.png";
import TestimonyImage2 from "../../assets/Braiders/WebsiteBraids2.png";
import TestimonyImage3 from "../../assets/Braiders/WebsiteBraids.png";

const PastWordBraids = forwardRef(function PastWordBraids(props, externalRef) {
  // Strip any accidental `ref` coming from prop spreads
  const { ref: _ignoredRef, className = "", ...rest } = props || {};

  const containerRef = useRef(null);

  const setContainerRef = useCallback((node) => {
    containerRef.current = node;
  }, []);

  const getScrollStep = () => {
    const el = containerRef.current;
    return el ? Math.min(Math.round(el.clientWidth * 0.9), 650) : 600;
  };

  const handleScrollLeft = () => {
    containerRef.current?.scrollBy({ left: -getScrollStep(), behavior: "smooth" });
  };

  const handleScrollRight = () => {
    containerRef.current?.scrollBy({ left: getScrollStep(), behavior: "smooth" });
  };

  const items = [
    { image: TestimonyImage3, name: "Case Study: Unruly", link: "https://un-ruly.com/" },
    { image: TestimonyImage1, name: "Case Study: Trend Salon", link: "/clientwork/jajas" },
    { image: TestimonyImage2, name: "Case Study: KADY Hair Braiding", link: "https://www.kadyafricanbraiding.com/" },
  ];

  return (
    <main
      ref={externalRef}
      className={`relative h-auto w-screen bg-[#F4F3E1] ${className}`}
      {...rest}
    >
      {/* Move <title>/<meta> to Head/index.html if needed */}
      <section className="bg-[#F7F3F2] py-12 relative">
        <h2 className="text-center text-2xl md:text-4xl text-black mb-10">
          Our Web Design Projects
        </h2>

        <div className="relative mx-auto max-w-[1200px] px-8">
          {/* edge fades */}
          <div className="pointer-events-none absolute left-0 top-0 h-full w-8 md:w-10 bg-gradient-to-r from-[#F7F3F2] to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-8 md:w-10 bg-gradient-to-l from-[#F7F3F2] to-transparent" />

          {/* Left Arrow */}
          <button
            type="button"
            onClick={handleScrollLeft}
            aria-label="Scroll left"
            className="absolute left-0 top-1/2 -translate-y-1/2 z-20 bg-[#CFF098] text-black rounded-full shadow p-2 hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#CFF098]"
          >
            <ChevronLeft size={20} />
          </button>

          {/* Scrollable rail */}
          <div
            ref={setContainerRef}
            className="flex overflow-x-auto gap-6 md:gap-8 py-2 md:py-4 scroll-smooth snap-x snap-mandatory hide-scrollbar m-10"
          >
            {items.map((item, index) => (
              <div key={index} className="snap-center min-w-[260px] sm:min-w-[420px] md:min-w-[540px] flex-shrink-0">
                <a href={item.link} className="group block">
                  <div className="w-full h-48 sm:h-64 md:h-80 overflow-hidden rounded-xl shadow-md group-hover:shadow-lg transition-shadow">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <p className="mt-3 text-center text-sm text-gray-800 uppercase tracking-wide">
                    {item.name}
                  </p>
                </a>
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          <button
            type="button"
            onClick={handleScrollRight}
            aria-label="Scroll right"
            className="absolute right-0 top-1/2 -translate-y-1/2 z-20 bg-[#CFF098] rounded-full text-black shadow p-2 hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#CFF098]"
          >
            <ChevronRight size={20} />
          </button>
        </div>

        <div className="flex flex-col items-center justify-center mt-8">
          <a href="/clientwork" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black uppercase">
            Browse Our Work →
          </a>
        </div>
      </section>
    </main>
  );
});

export default PastWordBraids;
